import "../styles/PopUp.css"
import { LuX, LuChevronLeft, LuLoaderCircle } from "react-icons/lu";
import { FaBook } from "react-icons/fa";
import { templateList, templateDetail, privacy, TeamTemplates, APIStatus } from "../constants/constant";
import { useState } from "react";
import DiagConfirmation from "./DiagConfirmation";
import TeamService from "../services/TeamService";

const CreateGroupPopup = (props) => {
    const { isOpen, onClose } = props;

    const [isExecuting, setIsExecuting] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [teamDetail, setTeamDetail] = useState({
        template: { id: "", name: "", status: false },
        isPublic: null,
        teamName: "",
        teamDescription: "",
    })

    const setTemplate = (id, name) => {
        setTeamDetail({
            ...teamDetail,
            template: {
                ...teamDetail.template,
                id: id || "",
                name: name || ""
            }
        });
    };


    const setTemplateStatus = (status) => {
        setTeamDetail({
            ...teamDetail,
            template: { ...teamDetail.template, status: status },
            isPublic: teamDetail.template.id === TeamTemplates.EDUCATION_CLASS ? true : null
        })

    }

    const closePopup = () => {
        if (teamDetail.isPublic) {
            setIsConfirmed(true);
        } else {
            setTeamDetail({
                template: { id: "", name: "", status: false },
                isPublic: null,
                teamName: "",
                teamDescription: "",
            });
            onClose();
        }
    }

    const { postCreateTeam } = TeamService();

    const createGroup = async (teamDetail) => {
        setIsExecuting(true);
        const group = {
            teamName: teamDetail.teamName,
            description: teamDetail.teamDescription,
            templateId: teamDetail.template.id,
            isPublic: teamDetail.isPublic,
        }
        try {
            const response = await postCreateTeam(group)
            if (response.status === APIStatus.success) {
                setIsExecuting(false);
                setIsSuccessful(true);
            } else console.error(response.data);
        } catch (error) {
            console.error("Error posting data: ", error);
        } finally {
            setIsExecuting(false)
        }
    }

    return (
        <>
            <div className={`overlay-layer ${isOpen ? "active" : ""}`} onClick={closePopup}>
                <div className="modal-block" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-block-content">
                        {teamDetail.isPublic === null ? (
                            <>
                                {!teamDetail.template.id && !teamDetail.template.status ? (
                                    <>
                                        <div className="popup-header">
                                            <label className="popup-title">Create a team from a template <LuX onClick={closePopup} /></label>
                                            <p>Skip the set up and use a template to get your team engaged quickly.</p>
                                        </div>
                                        <div className="template-section">
                                            {templateList.map((temp, index) => (
                                                <div key={index} className="template-card" onClick={() => setTemplate(temp.id, temp.name)}>
                                                    <img src={temp.image} alt="error" />
                                                    <div className="card-body">
                                                        <span className="template-title">{temp.name}</span>
                                                        <span className="template-description">{temp.description}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                ) : teamDetail.template.id && !teamDetail.template.status ? (
                                    <>
                                        <div className="popup-header">
                                            <label className="popup-title">{teamDetail.template.name} <LuX onClick={closePopup} /></label>
                                        </div>
                                        <span>{templateDetail[teamDetail.template.id]}</span>
                                        <span className="detail-1"><FaBook /> 1 Channel</span>
                                        <span className="detail-2"><FaBook /> General</span>
                                        <div className="buttons-container ed2">
                                            <button className="back" onClick={() => setTemplate()}><LuChevronLeft />Back</button>
                                            <button className="trigger" onClick={() => setTemplateStatus(true)}>Use this template</button>
                                        </div>
                                    </>
                                ) : teamDetail.template.id && teamDetail.template.id !== TeamTemplates.EDUCATION_CLASS && teamDetail.template.status && (
                                    <>
                                        <div className="popup-header">
                                            <label className="popup-title">What kind of team will this be? <LuX onClick={closePopup} /></label>
                                        </div>
                                        <div className="privacy-section">
                                            <span>Privacy</span>
                                            {privacy.map((pri, index) => (
                                                <div key={index} className="privacy-option" onClick={() => setTeamDetail({ ...teamDetail, isPublic: pri.id === 1 ? true : false })}>
                                                    <div
                                                        className="privacy-img-container"
                                                        style={{ backgroundColor: pri.id === 0 ? "#F9C0B3" : "#B7B7F1" }}>
                                                        <img className="privacy-img" src={pri.image} alt="" />
                                                    </div>
                                                    <div className="privacy-body">
                                                        <span className="privacy-title">{pri.name}</span>
                                                        <span className="privacy-description">{pri.description}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="buttons-container ed2">
                                            <button className="back" onClick={() => setTemplateStatus(false)}><LuChevronLeft />Back</button>
                                        </div>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="popup-header">
                                    <label className="popup-title">Some quick detail about your {teamDetail.isPublic ? "public" : "private"} team <LuX onClick={closePopup} /></label>
                                </div>

                                <div className="field">
                                    <label>Team name<b>*</b></label>
                                    <input
                                        type="text"
                                        placeholder="Give your team a name"
                                        value={teamDetail.teamName}
                                        onChange={(e) => setTeamDetail({ ...teamDetail, teamName: e.target.value })}
                                    ></input>
                                </div>
                                <div className="field">
                                    <label>Description</label>
                                    <textarea
                                        className="description"
                                        placeholder="Let people know what this team is all about"
                                        value={teamDetail.teamDescription}
                                        onChange={(e) => setTeamDetail({ ...teamDetail, teamDescription: e.target.value })}
                                    ></textarea>
                                </div>
                                <div className="buttons-container ed2">
                                    <button
                                        className="back"
                                        onClick={() =>
                                            setTeamDetail(prev => ({
                                                ...prev,
                                                template: {
                                                    ...prev.template,
                                                    status: prev.template.id === TeamTemplates.EDUCATION_CLASS ? false : prev.template.status
                                                },
                                                isPublic: null
                                            }))}><LuChevronLeft />Back</button>
                                    <button
                                        className="trigger"
                                        disabled={!teamDetail.teamName}
                                        title={!teamDetail.teamName ? "Missing team name" : ""}
                                        onClick={() => createGroup(teamDetail)}
                                    >Create</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <DiagConfirmation
                type={isSuccessful ? "successfully created" : "creating group"}
                isOpen={isConfirmed || isSuccessful}
                onClose={() => isConfirmed ? setIsConfirmed(false) : setIsSuccessful(false)}
                action1={() => {
                    setTeamDetail({
                        template: { id: "", name: "", status: false },
                        isPublic: null,
                        teamName: "",
                        teamDescription: "",
                    });
                    onClose();
                }}
            />

            {isExecuting && (
                <div
                    className="executing-overlay"
                    style={{ backgroundColor: "rgba(121, 121, 121, 0.2)" }}
                >
                    <span className="inform-creating">
                        <LuLoaderCircle /> Executing...
                    </span>
                </div>
            )}
        </>
    )
}
export default CreateGroupPopup;